<template>
  <el-dialog
    title="开票信息"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      :model="invoiceInfo"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="发票开具：">
        <el-radio-group v-model="invoiceInfo.vat_invoice_open_type" @change="handleInvoiceTypeChange">
          <el-radio :label="1">开票</el-radio>
          <el-radio :label="2">不开票</el-radio>
          <el-radio :label="4">待定</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <template v-if="invoiceInfo.vat_invoice_open_type == 1">
        <el-form-item label="开票类型：">
          <el-radio-group v-model="invoiceInfo.vat_invoice_type">
            <el-radio :label="1">普票</el-radio>
            <el-radio :label="2">专票</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <template v-if="invoiceInfo.vat_invoice_type == 1">
          <el-form-item label="开票抬头：">
            <el-radio-group v-model="invoiceInfo.vat_invoice_title">
              <el-radio :label="1">企业</el-radio>
              <el-radio :label="2">个人</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        
        <template v-if="invoiceInfo.vat_invoice_title == 2 && invoiceInfo.vat_invoice_type == 1">
          <el-form-item label="个人名称：">
            <el-input
              v-model="invoiceInfo.individual_title_name"
              placeholder="请输入个人名称"
            ></el-input>
          </el-form-item>
        </template>
        
        <template v-if="invoiceInfo.vat_invoice_title != 2 || invoiceInfo.vat_invoice_type == 2">
          <el-form-item label="纳税人名称：">
            <el-input
              v-model="invoiceInfo.tax_name"
              placeholder="请输入纳税人名称"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="税务登记号：">
            <el-input
              v-model="invoiceInfo.tax_no"
              placeholder="请输入税务登记号"
            ></el-input>
          </el-form-item>
        </template>
        
        <template v-if="invoiceInfo.vat_invoice_type == 2">
          <el-form-item label="税务登记地址：">
            <el-input
              v-model="invoiceInfo.tax_address"
              placeholder="请输入税务登记地址"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="税务登记联系电话：">
            <el-input
              v-model="invoiceInfo.tax_mobile"
              placeholder="请输入税务登记联系电话"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="税务开户银行名称：">
            <el-input
              v-model="invoiceInfo.tax_bank"
              placeholder="请输入税务开户银行名称"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="税务开户银行账号：">
            <el-input
              v-model="invoiceInfo.tax_bank_no"
              placeholder="请输入税务开户银行账号"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="一般纳税人证明：">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleTaxFileSuccess"
              :on-error="handleUploadError"
              :on-remove="handleTaxFileRemove"
              :file-list="taxFileList"
              :limit="1"
              :on-exceed="handleUploadExceed"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过2MB</div>
            </el-upload>
          </el-form-item>
          
          <el-form-item label="开票信息采集表：">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              :headers="uploadHeaders"
              :on-success="handleVatFileSuccess"
              :on-error="handleUploadError"
              :on-remove="handleVatFileRemove"
              :file-list="vatFileList"
              :limit="1"
              :on-exceed="handleUploadExceed"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png/pdf文件，且不超过2MB</div>
            </el-upload>
          </el-form-item>
        </template>
      </template>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDhGxbUserInfo, updateDhGxbUserInvoice } from '@/api/member'

export default {
  name: 'InvoiceInfo',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      invoiceInfo: {
        vat_invoice_open_type: 2,  // 发票状态，默认不开票
        vat_invoice_type: 1,       // 开票类型 1 普通 2 专用
        vat_invoice_title: 1,      // 发票抬头 1 企业 2 个人
        individual_title_name: '', // 个人名称
        tax_name: '',              // 纳税人名称
        tax_no: '',                // 税务登记号
        tax_address: '',           // 税务登记地址
        tax_mobile: '',            // 税务登记联系电话
        tax_bank: '',              // 税务开户银行名称
        tax_bank_no: '',           // 税务开户银行账号
        tax_file_url: '',          // 一般纳税人证明
        vat_file_url: ''           // 开票信息采集表
      },
      taxFileList: [],
      vatFileList: [],
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + (localStorage.getItem('jubao_admin_token') || localStorage.getItem('jubao_admin') || '')
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.userId) {
        this.fetchInvoiceInfo()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    
    handleInvoiceTypeChange(value) {
      // 当切换为不开票或待定时，重置相关字段
      if (value !== 1) {
        this.invoiceInfo.vat_invoice_type = 1
        this.invoiceInfo.vat_invoice_title = 1
      }
    },
    
    handleTaxFileSuccess(response, file, fileList) {
      this.taxFileList = fileList
      this.invoiceInfo.tax_file_url = response?.url || fileList[0]?.url || ''
      this.$message.success('上传成功')
    },
    
    handleVatFileSuccess(response, file, fileList) {
      this.vatFileList = fileList
      this.invoiceInfo.vat_file_url = response?.url || fileList[0]?.url || ''
      this.$message.success('上传成功')
    },
    
    handleTaxFileRemove(file, fileList) {
      this.taxFileList = fileList
      this.invoiceInfo.tax_file_url = ''
    },
    
    handleVatFileRemove(file, fileList) {
      this.vatFileList = fileList
      this.invoiceInfo.vat_file_url = ''
    },
    
    handleUploadError(err, file, fileList) {
      this.$message.error('上传失败')
    },
    
    handleUploadExceed(files, fileList) {
      this.$message.warning('只能上传一个文件')
    },
    
    async fetchInvoiceInfo() {
      this.loading = true
      try {
        const params = {
          id: this.userId
        }
        
        const res = await getDhGxbUserInfo(params)
        if (res.err_code === 0 && res.data) {
          const data = res.data
          this.invoiceInfo = {
            vat_invoice_open_type: data.vat_invoice_open_type || 2,
            vat_invoice_type: data.vat_invoice_type === 0 ? 1 : (data.vat_invoice_type || 1),
            vat_invoice_title: data.vat_invoice_title === 0 ? 1 : (data.vat_invoice_title || 1),
            individual_title_name: data.individual_title_name || '',
            tax_name: data.tax_name || '',
            tax_no: data.tax_no || '',
            tax_address: data.tax_address || '',
            tax_mobile: data.tax_mobile || '',
            tax_bank: data.tax_bank || '',
            tax_bank_no: data.tax_bank_no || '',
            tax_file_url: data.tax_file_url || '',
            vat_file_url: data.vat_file_url || ''
          }
          
          // 处理文件列表
          if (this.invoiceInfo.tax_file_url) {
            this.taxFileList = [{
              name: this.invoiceInfo.tax_file_url.split('/').pop(),
              url: this.invoiceInfo.tax_file_url
            }]
          }
          
          if (this.invoiceInfo.vat_file_url) {
            this.vatFileList = [{
              name: this.invoiceInfo.vat_file_url.split('/').pop(),
              url: this.invoiceInfo.vat_file_url
            }]
          }
          
          // 特殊处理：当开票类型为专票时，抬头强制为企业
          if (this.invoiceInfo.vat_invoice_open_type == 1 && this.invoiceInfo.vat_invoice_type == 2) {
            this.invoiceInfo.vat_invoice_title = 1
          }
        } else {
          this.$message.error('获取开票信息失败')
        }
      } catch (error) {
        console.error('获取开票信息失败:', error)
        this.$message.error('获取开票信息失败')
      } finally {
        this.loading = false
      }
    },
    
    async handleSubmit() {
      this.submitting = true
      try {
        const params = {
          id: this.userId,
          vat_invoice_open_type: this.invoiceInfo.vat_invoice_open_type
        }
        
        // 如果是开票状态，添加相关字段
        if (this.invoiceInfo.vat_invoice_open_type == 1) {
          params.vat_invoice_type = this.invoiceInfo.vat_invoice_type
          
          if (this.invoiceInfo.vat_invoice_type == 1) {
            // 普票
            params.vat_invoice_title = this.invoiceInfo.vat_invoice_title
            if (this.invoiceInfo.vat_invoice_title == 1) {
              // 企业
              params.tax_name = this.invoiceInfo.tax_name
              params.tax_no = this.invoiceInfo.tax_no
            } else {
              // 个人
              params.individual_title_name = this.invoiceInfo.individual_title_name
            }
          } else if (this.invoiceInfo.vat_invoice_type == 2) {
            // 专票
            params.tax_name = this.invoiceInfo.tax_name
            params.tax_no = this.invoiceInfo.tax_no
            params.tax_address = this.invoiceInfo.tax_address
            params.tax_mobile = this.invoiceInfo.tax_mobile
            params.tax_bank = this.invoiceInfo.tax_bank
            params.tax_bank_no = this.invoiceInfo.tax_bank_no
            params.tax_file_url = this.invoiceInfo.tax_file_url
            params.vat_file_url = this.invoiceInfo.vat_file_url
          }
        }
        
        const res = await updateDhGxbUserInvoice(params)
        if (res.err_code === 0) {
          this.$message.success('保存成功')
          this.$emit('success')
          this.handleClose()
        } else {
          this.$message.error(res.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存开票信息失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}

.upload-demo {
  width: 100%;
}
</style>